export default [
  {
    path: '/systemConfig',
    name: 'SystemConfig',
    component: () => import('./Config'),
    meta: {title: '系统设置'}
  },
]
